export const SET_ACTIVITY_PROGRESS = 'SET_ACTIVITY_PROGRESS'
export const SET_CHALLENGE_PROGRESS = 'SET_CHALLENGE_PROGRESS'
export const SET_BODYFAT_PROGRESS = 'SET_BODYFAT_PROGRESS'
export const SET_BODYWEIGHT_PROGRESS = 'SET_BODYWEIGHT_PROGRESS'
export const SET_MEMBERSHIP_PROGRESS = 'SET_MEMBERSHIP_PROGRESS'
export const SET_NUTRITION_PROGRESS = 'SET_NUTRITION_PROGRESS'
export const SET_DASHBOARD_PROGRESS = 'SET_DASHBOARD_PROGRESS'
export const SET_ANALYSIS_DATA = 'SET_ANALYSIS_DATA'
export const RESET_ANALYSIS_DATA = 'RESET_ANALYSIS_DATA'
export const SET_CHECKED = 'SET_CHECKED'
